module.exports = __webpack_public_path__ + "img/product_dietz_mgt.96cd84e9.jpg";